const INK = '#0e1013';
const MUTED = '#6b6459';
const BORDER = 'rgba(14,16,19,0.1)';

function TermsModal({ fullName, onClose }) {
    return (
        <div style={{
            position: 'fixed', inset: 0,
            background: 'rgba(14,16,19,0.55)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            zIndex: 100, padding: '16px'
        }}>
            <style>{`
                .terms-scope * { box-sizing: border-box; font-family: 'Helvetica Neue', Arial, sans-serif; }

                .terms-scroll {
                    scrollbar-width: thin;
                    scrollbar-color: #ccc transparent;
                }
                .terms-scroll::-webkit-scrollbar { width: 5px; }
                .terms-scroll::-webkit-scrollbar-track { background: transparent; }
                .terms-scroll::-webkit-scrollbar-thumb {
                    background: #ccc;
                }
                .terms-scroll::-webkit-scrollbar-thumb:hover { background: #999; }

                .wlink { position: relative; display: inline-block; cursor: pointer; opacity: 0.88; transition: opacity .25s ease; }
                .wlink:hover { opacity: 1; }
                .wlink::after { content: ''; position: absolute; left: 0; right: 0; bottom: -3px; height: 1px; background: currentColor; transform: scaleX(0); transform-origin: left; transition: transform .35s cubic-bezier(.4,0,.2,1); }
                .wlink:hover::after { transform: scaleX(1); }
            `}</style>

            <div className="terms-scope" style={{
                background: '#fff',
                width: '100%', maxWidth: '560px',
                maxHeight: '90vh', display: 'flex', flexDirection: 'column',
                overflow: 'hidden',
                border: `1px solid ${BORDER}`,
            }}>

                {/* Header */}
                <div style={{ padding: '28px 32px 18px', borderBottom: `1px solid ${BORDER}`, display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: '16px' }}>
                    <div>
                        <p style={{
                            fontSize: '10px', letterSpacing: '0.25em', textTransform: 'uppercase',
                            color: MUTED, margin: '0 0 10px', fontWeight: 700,
                        }}>
                            winston.ie · a Longden Collective label
                        </p>
                        <h3 style={{
                            fontWeight: 700, fontSize: '20px', color: INK, margin: 0,
                            letterSpacing: '-0.01em',
                        }}>
                            Contributor Terms
                        </h3>
                    </div>
                    <button
                        onClick={onClose}
                        aria-label="Close"
                        className="wlink"
                        style={{
                            background: 'none', border: 'none', cursor: 'pointer',
                            fontSize: '16px', fontWeight: 700, color: MUTED, lineHeight: 1, padding: '4px',
                        }}
                    >
                        ✕
                    </button>
                </div>

                {/* Scrollable terms */}
                <div
                    className="terms-scroll"
                    style={{
                        flex: 1, overflowY: 'auto', padding: '24px 32px',
                        fontSize: '13.5px', fontWeight: 500, color: '#3a3632', lineHeight: '1.85'
                    }}
                >
                    <p style={{
                        color: MUTED, marginBottom: '24px', fontSize: '13px', fontWeight: 500, lineHeight: '1.75',
                        borderLeft: `2px solid ${INK}`, paddingLeft: '16px',
                    }}>
                        This Agreement governs the relationship between winston.ie, a label of Longden Collective, and any contributor who publishes creative work on the platform. By checking the box and creating an account on winston.ie, you agree to the following.
                    </p>

                    <Term number="1" title="Public Brand & Administrative Ownership">
                        winston.ie is the public-facing brand under which this platform operates. Administratively, and for purposes of copyright, attribution, and internal organization, winston.ie is a label of Longden Collective. This distinction exists for organizational clarity: you interact with winston.ie as the visible identity, while Longden Collective represents the broader creative ecosystem under which winston.ie, throughmyeyes, and Ardoise each operate as distinct labels.
                    </Term>

                    <Term number="2" title="Copyright & Attribution">
                        You retain full copyright over all work you publish on winston.ie. Publishing on this platform does not transfer intellectual property ownership to winston.ie, Longden Collective, or any third party. You affirm that all submitted work is original and does not infringe upon the rights of any third party. You will always be credited as the original creator, using the name provided at the time of publishing, which may not be altered without your consent. Published works carry the notice "© [Your Name] — winston.ie 2026." Site-wide content and platform design carry the separate notice "© winston.ie 2026. All rights reserved. A Longden Collective label."
                    </Term>

                    <Term number="3" title="Creative Catalogue">
                        By publishing on winston.ie, your work becomes part of the official winston.ie creative catalogue. winston.ie may present, submit, and exhibit this work as part of its institutional portfolio in competitions, festivals, partnerships, and exhibitions — with full credit attributed to you as the original creator at all times.
                    </Term>

                    <Term number="4" title="Licence & Primary Publishing Right">
                        You grant winston.ie / Longden Collective a worldwide, royalty-free licence to publish, display, share, distribute, and use your work as part of the winston.ie platform and its associated projects — including partnerships, collaborations, promotional campaigns, and external exhibitions. This licence remains in effect for the duration of your work's presence on the platform and constitutes a primary, non-exclusive publishing right: you retain full rights to share, republish, or display the same work on personal social media accounts, portfolios, resumes, or CVs. You agree not to publish the same work through another official photography distribution platform, stock agency, or competing curated platform without prior written permission from winston.ie.
                    </Term>

                    <Term number="5" title="Intermediary & Representation">
                        winston.ie acts as your label and sole representative for any third-party requests involving your published work — including usage requests, reproduction, licensing to external parties, and collaboration opportunities. Any such request will be communicated to you. Your explicit written consent is required before any external use is approved. winston.ie will not act on your behalf without prior knowledge and consent.
                    </Term>

                    <Term number="6" title="Commercial Revenue">
                        If your published work generates commercial revenue through winston.ie — whether through licensing, partnerships, sales, or other means — a revenue-sharing arrangement will be discussed and agreed upon separately with you prior to any commercial transaction. winston.ie commits to full transparency in all revenue matters involving your work.
                    </Term>

                    <Term number="7" title="Content Standards">
                        You agree that submitted content is original work, does not infringe on third-party rights, and complies with winston.ie's community and content guidelines as published from time to time.
                    </Term>

                    <Term number="8" title="Removal & Withdrawal">
                        You may request removal of your published work at any time by contacting winston.ie at contact@winston.longden.site . Removal requests will be processed within 14 days of receipt. Upon removal, the licence granted under Section 4 is terminated for future use; existing third-party agreements entered into prior to the removal request remain valid and enforceable.
                    </Term>

                    <Term number="9" title="No Employment or Partnership">
                        Nothing in this Agreement establishes an employment, partnership, or agency relationship between you and winston.ie or Longden Collective.
                    </Term>

                    <Term number="10" title="Governing Law">
                        This Agreement is governed by the laws of the Province of Quebec and the federal laws of Canada applicable therein. Any disputes arising under this Agreement shall be resolved in the courts of Montreal, Quebec.
                    </Term>

                    <Term number="11" title="Operating Status">
                        Longden Collective and winston.ie are not, as of the date of this Agreement, legally incorporated entities. This Agreement is made in good faith between you and the sole owner and operator of these platforms. Should Longden Collective or winston.ie become a formally incorporated entity in the future, this Agreement and its terms will carry forward under that entity without requiring re-signature, unless you are notified otherwise.
                    </Term>

                    <Term number="12" title="Governing Language">
                        This Agreement is available in French, English, and Vietnamese for your convenience. In the event of any discrepancy between versions, the version accepted by you on the platform shall govern.
                    </Term>

                    <div style={{
                        marginTop: '28px', padding: '16px 18px',
                        background: '#faf9f6', borderLeft: `2px solid ${INK}`,
                        fontSize: '12px', fontWeight: 500, color: MUTED, lineHeight: '1.75',
                    }}>
                        Checking the agreement box on the sign-up form constitutes your full acceptance of this Agreement, effective as of the date your account is created.
                    </div>
                </div>

                {/* Footer */}
                <div style={{ padding: '18px 32px 26px', borderTop: `1px solid ${BORDER}`, textAlign: 'center' }}>
                    <button
                        onClick={onClose}
                        className="wlink"
                        style={{
                            background: 'none',
                            color: INK,
                            border: 'none',
                            fontSize: '14px', fontWeight: 700,
                            letterSpacing: '0.01em',
                            cursor: 'pointer',
                            padding: 0,
                        }}
                    >
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
}

function Term({ number, title, children }) {
    return (
        <div style={{ marginBottom: '20px' }}>
            <p style={{
                fontWeight: 700, fontSize: '10.5px',
                color: INK, letterSpacing: '0.14em', textTransform: 'uppercase',
                marginBottom: '5px',
            }}>
                {number} — {title}
            </p>
            <p style={{ margin: 0, fontSize: '13.5px', fontWeight: 500, color: '#3a3632', lineHeight: '1.85' }}>
                {children}
            </p>
        </div>
    );
}

export default TermsModal;